import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrPaymentGatewaySwitch.ts
var t = () => e("paymentGatewaySwitch");
//#endregion
export { t as useTrPaymentGatewaySwitch };
